export default __webpack_public_path__ + "static/media/logo.afd3ce1d.png";